var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnExportInGnb = function SvgIcnExportInGnb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.0625H6.75C2.6775 17.0625 0.9375 15.3225 0.9375 11.25V6.75C0.9375 2.6775 2.6775 0.9375 6.75 0.9375H11.25C15.3225 0.9375 17.0625 2.6775 17.0625 6.75V11.25C17.0625 15.3225 15.3225 17.0625 11.25 17.0625ZM6.75 2.0625C3.2925 2.0625 2.0625 3.2925 2.0625 6.75V11.25C2.0625 14.7075 3.2925 15.9375 6.75 15.9375H11.25C14.7075 15.9375 15.9375 14.7075 15.9375 11.25V6.75C15.9375 3.2925 14.7075 2.0625 11.25 2.0625H6.75Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.69502C11.1075 7.69502 10.965 7.64252 10.8525 7.53002L8.99996 5.67753L7.14745 7.53002C6.92995 7.74752 6.56996 7.74752 6.35246 7.53002C6.13496 7.31252 6.13496 6.95252 6.35246 6.73502L8.60246 4.48502C8.81996 4.26752 9.17995 4.26752 9.39745 4.48502L11.6475 6.73502C11.865 6.95252 11.865 7.31252 11.6475 7.53002C11.535 7.64252 11.3925 7.69502 11.25 7.69502Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.4448C8.6925 11.4448 8.4375 11.1898 8.4375 10.8823V4.88226C8.4375 4.57476 8.6925 4.31976 9 4.31976C9.3075 4.31976 9.5625 4.57476 9.5625 4.88226V10.8823C9.5625 11.1973 9.3075 11.4448 9 11.4448Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 13.673C7.41746 13.673 5.82746 13.418 4.31996 12.9155C4.02746 12.818 3.86996 12.4955 3.96746 12.203C4.06496 11.9105 4.38747 11.7455 4.67997 11.8505C7.46997 12.7805 10.5375 12.7805 13.3275 11.8505C13.62 11.753 13.9425 11.9105 14.04 12.203C14.1375 12.4955 13.98 12.818 13.6875 12.9155C12.1725 13.4255 10.5825 13.673 8.99996 13.673Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnExportInGnb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_export_in_gnb.96d3c8f8.svg";
export { ForwardRef as ReactComponent };